module.exports = __webpack_public_path__ + "static/1035544898.83331ab7.jpg";